<ng-template #stepLabel let-step>
  @if (step.stepLabel) {
  <ng-container [ngTemplateOutlet]="step.stepLabel.template"></ng-container>
  } @else {
  {{ step.label }}
  }
</ng-template>

<button
  type="button"
  class="mobile-stepper__bar"
  (click)="toggle()"
  [attr.aria-expanded]="isOpen"
  [attr.aria-label]="
    (isOpen
      ? 'shared.mobile-stepper.hide-steps'
      : 'shared.mobile-stepper.show-steps'
    ) | translate
  "
  data-testid="mobile_stepper_btn_toggle"
>
  <mat-icon class="mobile-stepper__menu-icon">menu</mat-icon>
  @if (selectedStep) {
  <span class="mobile-stepper__current">
    <span class="mobile-stepper__current-number">{{ selectedIndex + 1 }}</span>
    <span class="mobile-stepper__current-label">
      <ng-container
        [ngTemplateOutlet]="stepLabel"
        [ngTemplateOutletContext]="{ $implicit: selectedStep }"
      ></ng-container>
    </span>
  </span>
  }
</button>

@if (isOpen) {
<div
  class="mobile-stepper__backdrop"
  [style.top.px]="panelTop"
  (click)="close()"
  data-testid="mobile_stepper_backdrop"
></div>

<nav
  class="mobile-stepper__panel"
  [style.top.px]="panelTop"
  [attr.aria-label]="'shared.mobile-stepper.steps' | translate"
>
  <ol class="mobile-stepper__list">
    @for (step of steps; track step; let i = $index) {
    <li
      class="mobile-stepper__item"
      [class.is-active]="i === selectedIndex"
      [class.is-done]="isDone(step, i)"
    >
      <button
        type="button"
        class="mobile-stepper__step"
        [disabled]="!canSelect(i)"
        [attr.aria-current]="i === selectedIndex ? 'step' : null"
        (click)="select(i)"
        [attr.data-testid]="'mobile_stepper_btn_step_' + i"
      >
        <span class="mobile-stepper__index">
          @if (isDone(step, i)) {
          <mat-icon>done</mat-icon>
          } @else {
          {{ i + 1 }}
          }
        </span>
        <span class="mobile-stepper__label">
          <ng-container
            [ngTemplateOutlet]="stepLabel"
            [ngTemplateOutletContext]="{ $implicit: step }"
          ></ng-container>
        </span>
      </button>
    </li>
    }
  </ol>
</nav>
}
